export const saveSetting = (state, setting) => {
  const settings = Object.assign({}, state.settings, setting)
  localStorage.setItem('user-settings', JSON.stringify(settings))
  state.settings = settings
}

export const saveVoices = (state, voices) => {
  state.voices = voices
}
